import { faTrashAlt } from "@fortawesome/pro-regular-svg-icons/faTrashAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton } from "@mui/material";
import { MprcConfirmDialog } from "components";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";
import { useCardManagerStyles } from "views/knowledge/components/card/CardManagerStyles";
import { publish } from "views/knowledge/feed/FeedEvents";

///
export const FeedListIconActions = () => {

    const { pub: { publicationId, interaction: { allowDelete } }, otherInfo } = useCardContext();

    const api = useCoreApi();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation("knowledge");

    const [dialog, setDialog] = useState<React.ReactNode | null>(null);
    const [deleteId, setDeleteId] = useState<string | null>(null);
    const { classes } = useCardManagerStyles();

    ///
    const doRemoveFromList = useCallback(() => {
        setDialog(<MprcConfirmDialog
            open
            severity="danger"
            message={<span>{t("Feed.Card.List.ConfirmDeleteMessage")}</span>}
            onClose={
                (result) => {
                    if (result) {
                        setDeleteId(publicationId);
                    }
                    setDialog(null);
                }
            }
        />);
    }, []);

    /// Ao remover uma publicação da lista
    useEffect(() => {
        async function postData() {
            try {
                if (deleteId) {
                    var result = await api.v1.knowledgePublication.removeListItem({
                        listPublicationId: otherInfo.listInfo.publicationId,
                        itemPublicationId: deleteId
                    });

                    if (result) {
                        enqueueSnackbar(t("Feed.Card.List.DeleteSuccessMessage"), { variant: "success" });
                        publish("ListReload", otherInfo.listInfo.publicationId);
                    }
                    else {
                        enqueueSnackbar(t("Feed.Card.List.DeleteErrorMessage"), { variant: "error" });
                    }
                }
            }
            catch { }
            setDeleteId(null);
        }

        postData();

    }, [deleteId]);

    return (
        <>
            {
                otherInfo?.listInfo?.permissions?.canAddItems === true
                    ?
                    <>
                        {dialog}

                        <div style={{ height: 24 }} className={classes.cardMouseOut}>
                            {
                                allowDelete &&
                                <IconButton color="error" size="small" onClick={doRemoveFromList}>
                                    <FontAwesomeIcon icon={faTrashAlt} fixedWidth />
                                </IconButton>
                            }
                        </div>
                    </>
                    : null
            }
        </>
    );
};
